module.exports = __webpack_public_path__ + "media/25_Long.47952f21.mp3";